import Complete from 'components/InstantActions/components/Complete';
import CustomForms from 'components/InstantActions/components/CustomForms';
import InstantAuth from 'components/InstantActions/components/InstantAuth';
import InstantPacket from 'components/InstantActions/components/InstantPacket';
import InstantActionPage from 'components/InstantActions/wrapper';
import NotFound from 'components/NotFound';
import PersonalId from 'components/Patient/checkin/PersonalId/PersonalId';
import PersonalInformationContainer from 'components/Patient/checkin/PersonalInfo/PersonalInfo';
import PreAuth2 from 'components/Patient/checkin/PreAuth';
import ReturnCheck from 'components/Patient/checkin/ReturnCheck';
import HipaaFormContainer from 'components/Patient/checkin/hipaa_form_container';
import Insurance from 'components/Patient/checkin/insurance';
import NewInvoice from 'components/public/NewInvoice';

const INSTANT = [
  {
    path: 'ia/:token',
    element: <InstantActionPage />
  },
  {
    path: 'ia/auth/:token',
    element: <InstantAuth />
  },
  {
    path: 'invoice/:token',
    element: <NewInvoice />
  },
  {
    path: 'instant-packet',
    element: <InstantPacket />,
    children: [
      { path: 'personal-info', element: <PersonalInformationContainer /> },
      { path: 'form/:id', element: <CustomForms /> },
      { path: 'hipaa', element: <HipaaFormContainer /> },
      { path: 'personal-id', element: <PersonalId /> },
      { path: 'insurance', element: <Insurance /> },
      { path: 'pre-auth', element: <PreAuth2 /> },
      { path: 'complete', element: <Complete /> },
      { path: 'return-check', element: <ReturnCheck /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default INSTANT;
